module.exports = __webpack_public_path__ + "img/990RecActive2.bd9844d3.png";